import React, { useState } from 'react';
import styled from 'styled-components';
import { useNavigate } from "react-router-dom";
import axios from 'axios';
import Dropdown from './Dropdown';

const AgregarContacto = ({ openAddContact, setOpenAddContact, userId, setRefresh }) => {
    const navigate = useNavigate();
    const listAsesores = ['Enzo', 'Enzo2', 'Enzo3', 'Otros', 'asdasda'];
    const [formData, setFormData] = useState({
        nombre: '',
        apellido: '',
        telefono: '',
        email: '',
        ramo: '',
        asesorAsignado: '',
    });
    const [errors, setErrors] = useState({});
    const [isSubmitting, setIsSubmitting] = useState(false);

    const volverAtrazBtn = () => {
        setOpenAddContact(false)
        navigate('/contacts');
    };

    const validateField = (name, value) => {
        let error = '';
        if (!value) {
            error = 'Campo obligatorio';
        } else {
            if (name === 'email' && !/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i.test(value)) {
                error = 'Formato de email inválido';
            }
            if (name === 'telefono' && !/^\d{10,15}$/.test(value)) {
                error = 'Formato de teléfono inválido';
            }
        }
        setErrors(prevErrors => ({
            ...prevErrors,
            [name]: error,
        }));
    };

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData({
            ...formData,
            [name]: value,
        });
        validateField(name, value);
    };

    const handleCreateContact = async () => {
      

        if (
            formData.nombre &&
            formData.apellido &&
            formData.telefono &&
            formData.email &&
            formData.ramo
        ) {
            setIsSubmitting(true);
            try {
                const response = await axios.post(
                    'https://crmmerci.testeoenzo.online/api/contact/create',
                    {
                        userId,
                        name: formData.nombre,
                        lastname: formData.apellido,
                        phone: formData.telefono,
                        email: formData.email,
                        ramo: formData.ramo,
                        asesorAsignado: formData.userId,
                        status:"No Contactado"
                    }
                );
                console.log('Contacto creado:', response.data);
                // alert("Contacto creado exitosamente");
                setOpenAddContact(false);
                setRefresh(true)
                navigate('/contacts');
                window.location.reload();
            } catch (error) {
                console.error('Error al crear el contacto:', error);
                // alert("Error al crear el contacto");
            } finally {
                setIsSubmitting(false);
            }
        } else {
            console.log('El formulario no es válido. Por favor, corrija los errores.');
        }
    };

    return (
        <ModalWrapper>
            <FormContainer>
                <FormGroup>
                    <Label htmlFor="nombre">Nombre *</Label>
                    <Input
                        type="text"
                        id="nombre"
                        name="nombre"
                        value={formData.nombre}
                        onChange={handleChange}
                        placeholder='Ingrese nombre'
                    />
                    {errors.nombre && <ErrorMessage>{errors.nombre}</ErrorMessage>}
                </FormGroup>

                <FormGroup>
                    <Label htmlFor="apellido">Apellido *</Label>
                    <Input
                        type="text"
                        id="apellido"
                        name="apellido"
                        value={formData.apellido}
                        placeholder='Ingrese apellido'
                        onChange={handleChange}
                    />
                    {errors.apellido && <ErrorMessage>{errors.apellido}</ErrorMessage>}
                </FormGroup>

                <FormGroup>
                    <Label htmlFor="telefono">Teléfono *</Label>
                    <Input
                        type="text"
                        id="telefono"
                        name="telefono"
                        value={formData.telefono}
                        placeholder='Ej: 2213554599'
                        onChange={handleChange}
                    />
                    {errors.telefono && <ErrorMessage>{errors.telefono}</ErrorMessage>}
                </FormGroup>

                <FormGroup>
                    <Label htmlFor="email">Email *</Label>
                    <Input
                        type="email"
                        id="email"
                        name="email"
                        value={formData.email}
                        placeholder='Ingrese email'
                        onChange={handleChange}
                    />
                    {errors.email && <ErrorMessage>{errors.email}</ErrorMessage>}
                </FormGroup>

                <FormGroup>
                    <Label htmlFor="ramo">Ramo *</Label>
                    <Dropdown
                        options={['Auto', 'Moto', 'Casa', 'Otros']}
                        selectedOption={formData.ramo}
                        setSelectedOption={(option) => setFormData({ ...formData, ramo: option })}
                    />
                </FormGroup>

                <ContainerPaginationButtons>
                    <Boton1 onClick={volverAtrazBtn}>Volver</Boton1>
                    <Boton1 onClick={() => handleCreateContact()} disabled={errors.email}>
                        {isSubmitting ? "Creando..." : "Crear Contacto"}
                    </Boton1>
                </ContainerPaginationButtons>
            </FormContainer>
        </ModalWrapper>
    );
};

export default AgregarContacto;

// Estilos del componente

const FormContainer = styled.div`
display: grid;
grid-template-columns: auto auto;
width: auto;
align-items: center;
background-color: #FFFFFF;
box-shadow: rgba(0, 0, 0, 0.16) 0px 1px 4px;
border-radius: 8px;
padding: 16px;
gap: 16px;
justify-content: flex-start;
align-content: center;
`;


// Los estilos siguen igual...



const Form = styled.form`
display: flex;
width: auto;
align-items: center;
max-width: 445px;
min-width:auto;
background-color: #FFFFFF;
box-shadow: rgba(0, 0, 0, 0.16) 0px 1px 4px;
border-radius: 8px;
margin: 20vh 32px 32px 32px;
padding: 16px;
flex-wrap: wrap;
gap: 16px;
justify-content: flex-start;
align-content: center;

`;

const FormGroup = styled.div`
margin-bottom: 20px;
display:flex;
flex-direction: column;
gap:8px;
min-height:85px;
`;

const Label = styled.label`
font-family: 'Montserrat', sans-serif;
font-weight: 800;
font-size: 14px;
color: #07082c;
`;

const Input = styled.input`
padding: 8px;
border: 1px solid #ccc;
border-radius: 4px;
font-size: 16px;
`;

const ErrorMessage = styled.div`
color: red;
font-size: 14px;
font-family: 'Montserrat', sans-serif;
font-weight: 800;
font-size: 11px;

`;
const ModalWrapper = styled.div`
position: fixed;
top: 0;
left: 0;
width: 100%;
height: 100%;
background-color: rgba(0, 0, 0, 0.5);
display: flex;
justify-content: center;
align-items: center;
z-index: 1000;
`;
const ContainerPaginationButtons = styled.div`
width: 100%;
display: flex;
flex-direction: row;
gap: 8px;
align-items: center;
padding: 0.5em 0.5em 0.5em;
align-self: center;
justify-content: space-between;
`;
const Boton1 = styled.button`
background-color: #f8f9fa;
border: 1px solid #f8f9fa;
border-radius: 4px;
border-color: #dadce0;
box-shadow: rgba(0, 0, 0, .1) 0 1px 1px;
color: #202124;
cursor: pointer;
font-family: 'Montserrat', sans-serif;
font-weight: 500;
font-size: 14px;
color: #07082c;
height: 36px;
line-height: 27px;
min-width: 54px;
padding: 0 16px;
text-align: center;
user-select: none;
-webkit-user-select: none;
touch-action: manipulation;
white-space: pre;
width: auto;
min-width:auto;
&:focus {
border-color: #380418;
outline: none;
}
&:hover {
box-shadow: #38041852 0px 2px 16px 0px, rgba(255, 255, 255, 0.8) -6px -2px 16px 0px;

}
`;

const ContainerBox = styled.div`
width: -webkit-fill-available;
height: auto;
min-height: 95vh;
max-height: 95vh;
overflow-y: hidden;
max-width: calc(100vw - 84px);
gap: 16px;
display: flex;
flex-direction: row;
align-items: flex-start;
margin: 1% 16px 0px 90px;
background-color:#FFFFFF;
border-radius:8px;
box-shadow: 0px 1.5px 2px 0px rgba(16, 24, 40, 0.10);
border: 1px solid var(--Neutral-Gray-Gray-100, #E0E2E7);
`;